module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_16.e0d2c832.png";